import { KeyboardEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight, faPen, faPlus, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";

import { useCache } from "../../hooks/useCache";
import { Topo } from "../../components/Topo";

import "./style.css";
import { IListRequest, IProduto } from "../../global/types";
import { checkToken } from "../../utils/checkToken";
import { api } from "../../services/api";
import { Input } from "../../components/Input";
import { Load } from "../../components/Load";
import { currencyFormatter } from "../../utils/currencyFormatter";

const limitPage = 25;

export function Produtos() {
  const navigate = useNavigate();

  const { refreshToken, usuario, cacheTokens, token, setAlert } = useCache();
  const cacheError = { refreshToken, usuario, cacheTokens };

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [pesquisa, setPesquisa] = useState("");
  const [loading, setLoading] = useState(false);

  const [listProdutos, setListProdutos] = useState<IProduto[]>([]);

  const loadProdutos = async (canPesquisa = false) => {
    if (!token)
      return;

    setLoading(true);

    const rsCheckToken = await checkToken(cacheError, token);
    if (rsCheckToken.redirectLogin)
      navigate("/login");

    let dataRequest: IListRequest = {
      cursor: (limitPage * page) - limitPage,
      limit: limitPage
    }

    if (canPesquisa)
      dataRequest = { ...dataRequest, pesquisa };

    await api.post("produtos/findAll", dataRequest)
      .then((response) => {
        if (!response.data)
          return;

        const newMaxPage = Math.ceil(response.data.total / limitPage);

        setMaxPage(newMaxPage < 1 ? 1 : newMaxPage);
        setListProdutos(response.data.result);
      })
      .catch(async (err) => {
        if (err.response.status !== 401)
          setAlert(err.response.data.message, "danger");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handlePesquisa = () => {
    setPage(1);
    loadProdutos(true);
  }

  const handleKeyPesquisa = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter")
      handlePesquisa();
  }

  const handleDelete = async (id: string) => {
    if (!token)
      return;

    if (!window.confirm("Deseja realmente excluir este produto?"))
      return;

    setLoading(true);

    const rsCheckToken = await checkToken(cacheError, token);
    if (rsCheckToken.redirectLogin)
      navigate("/login");

    await api.delete('produtos', { data: { id } })
      .then((result) => { })
      .catch((err) => {
        if (err.response.status !== 401)
          setAlert(err.response.data.message, "danger");
      })
      .finally(() => {
        loadProdutos(true);
      });

  };

  useEffect(() => {
    loadProdutos();
  }, [token]);

  useEffect(() => {
    loadProdutos(true);
  }, [page]);

  return (
    <Topo page="Produtos" title="Produtos">
      <>
        <div className="divPesquisa">
          <Input
            mask="none"
            value={pesquisa}
            inputMaskChange={setPesquisa}
            placeholder="Pesquisa..."
            onKeyUp={handleKeyPesquisa}
          />
          <button onClick={handlePesquisa}>
            <FontAwesomeIcon icon={faSearch} />
          </button>
          <button className="btn-green" onClick={() => { navigate("/produtos/novo") }}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        <div className="gridContext">
          <div className="headTable">
            <span style={{ width: "200px" }}>Nome</span>
            <span style={{ width: "150px", textAlign: "right" }}>Valor</span>
            <span style={{ width: "200px", textAlign: "center" }}>Ações</span>
          </div>

          <div className="contentTable">
            {loading && (
              <Load txtLoading="Carregando..." options={{ height: 120, width: 120 }} />
            )}

            {!loading && listProdutos.length > 0 && (
              listProdutos.map((item) => (
                <div className="rowTable" key={item.id}>
                  <span style={{ width: "200px" }}>{item.nome}</span>
                  <span style={{ width: "150px", textAlign: "right" }}>{currencyFormatter(parseFloat(`${item.preco}`))}</span>
                  <span style={{ width: "200px", textAlign: "center" }}>
                    <button className="btn-orange" onClick={() => { navigate(`/produtos/${item.id}`) }}>
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                    <button className="btn-red" onClick={() => handleDelete(item.id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </span>
                </div>
              ))
            )}

          </div>

          <div className="pagination">
            {page !== 1 && (
              <FontAwesomeIcon icon={faAngleDoubleLeft} style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setPage(i => --i)} />
            )}
            <p>
              {page}/{maxPage}
            </p>
            {page !== maxPage && (
              <FontAwesomeIcon icon={faAngleDoubleRight} style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => setPage(i => ++i)} />
            )}
          </div>

        </div>

      </>
    </Topo>
  );
}